import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import theme from "../../utils/theme";
import PartTable from "../Common/PartTable";

/**
 * Styles for the component
 */
const styles = {
  headerBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 3,
  },
  title: {
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
};

/**
 * PartTemplateTable component for displaying painting template parts
 *
 * @param {Object} template - The selected template object with parts data
 * @param {boolean} loading - When true, show loader instead of table
 */
const PartTemplateTable = ({ template, onEdit, loading = false }) => {
  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Box sx={styles.headerBox}>
        <Typography variant="h6" sx={styles.title}>
          {`Painting Template (${template?.model?.model_name || ""})`}
        </Typography>
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <PartTable
          viewOnly={true}
          data={
            template?.painting_checklist_template_parts?.length > 0
              ? template?.painting_checklist_template_parts
              : []
          }
          onEdit={onEdit}
          striped={true}
          images={template?.painting_checklist_template_images}
          showStageFields={false}
        />
      )}
    </Box>
  );
};

export default PartTemplateTable;
